import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardSidebarService {

  private sidebarVisibleSource = new BehaviorSubject<boolean>(false);
  sidebarVisible$ = this.sidebarVisibleSource.asObservable();


  private sidebarDataSource = new BehaviorSubject(null)
  currentSidebarData$ = this.sidebarDataSource.asObservable()
  
   showSidebar(data: any) {
    this.sidebarDataSource.next(data);
    this.sidebarVisibleSource.next(true);
  }

  hideSidebar() {
    this.sidebarVisibleSource.next(false);
  }

  constructor() { }
}
